import { useCallback, useState } from 'react';

export interface ZoomLevel {
  // Multiplier for timeline width
  granularity: 'month' | 'week' | 'day';
  label: string;
  level: number;
  timelineWidth: number; // Timeline increment granularity
}

const ZOOM_LEVELS: ZoomLevel[] = [
  { level: 1, label: '', timelineWidth: 1, granularity: 'month' },
  { level: 2, label: '', timelineWidth: 4, granularity: 'day' },
  { level: 3, label: '', timelineWidth: 8, granularity: 'day' },
];

export const useZoomLevel = () => {
  const [currentZoomIndex, setCurrentZoomIndex] = useState(0); // Start with zoomed out

  const currentZoom = ZOOM_LEVELS[currentZoomIndex];

  const zoomIn = useCallback(() => {
    setCurrentZoomIndex(prev => Math.min(prev + 1, ZOOM_LEVELS.length - 1));
  }, []);

  const zoomOut = useCallback(() => {
    setCurrentZoomIndex(prev => Math.max(prev - 1, 0));
  }, []);

  const canZoomIn = currentZoomIndex < ZOOM_LEVELS.length - 1;
  const canZoomOut = currentZoomIndex > 0;

  return {
    currentZoom,
    zoomIn,
    zoomOut,
    canZoomIn,
    canZoomOut,
    zoomLevels: ZOOM_LEVELS,
  };
};
